export default __webpack_public_path__ + "static/media/hht2_ep11_speaking_03.1331a054.png";